export default (self) => {
  return [
    {
      value: "actions",
      sortable: false,
      align: "center",
      width: 25,
    },
    {
      value: "insertedAt",
      text: "Created At",
      width: 150,
      sortable: true,
    },
    {
      value: "recipients",
      text: "Recipients",
      width: 175,
      sortable: true,
      filter: (value) =>
        !self.recipients || value?.toLowerCase().includes(self.recipients),
    },
    {
      value: "cameraIds",
      text: "Camera IDs",
      width: 175,
      sortable: false,
    },
    {
      value: "failedCameraIds",
      text: "Camera IDS (Failed)",
      width: 175,
      sortable: false,
    },
    {
      value: "subject",
      text: "Subject",
      width: 175,
      sortable: false,
    },
  ]
}
